const headerA11y = () => {
	const bypassLinks = document.querySelector('.bypass-links') || null;
	const header = document.querySelector('.header');
	const menu = header.querySelector('.menu');
	// Gestion des liens de contournement
	if (bypassLinks) {
		document.addEventListener('keyup', (e) => {
			if (e.key === 'Tab') {
				if (document.activeElement.classList.contains('bypass-link')) {
					bypassLinks.classList.remove('visually-hidden');
					header.classList.add('bypass-links--focus');
				} else {
					bypassLinks.classList.add('visually-hidden');
					header.classList.remove('bypass-links--focus');
				}
			}
		});
	}
	if (menu) {
		const menuItems = menu.querySelectorAll('.menu-item a');

		menuItems.forEach((item) => {
			item.addEventListener('keydown', (e: KeyboardEvent) => {
				e.preventDefault();
				const shiftTab: boolean = e.shiftKey && e.key === 'Tab';
				const down: boolean = e.key === 'ArrowDown';
				const up: boolean = e.key === 'ArrowUp';
				const tab: boolean = e.key === 'Tab';
				const escape: boolean = e.key === 'Escape';
				const parent = item.parentNode as HTMLElement;
				const hasChildren: boolean = parent.classList.contains(
					'menu-item-has-children'
				);
				// Gestion de la touche down
				if (down) {
					if (hasChildren) {
						const submenu =
							parent.querySelector('.sub-menu') || null;
						// on déplie sous-menu
						if (submenu) {
							submenu.classList.add('sub-menu--a11Y');
							submenu.querySelector('a').focus();
						}
						// Sinon on le replie et on cible le bon élément
						else {
							const parentEl = parent.parentNode.parentNode.parentNode as HTMLElement;
							parentEl.classList.remove(
								'sub-menu--a11Y'
							);
							// Si dernier element du menu on va cibler le prochain bloc
							if (item === menuItems[menuItems.length - 1]) {
								document
									.getElementById('a42-ac-button')
									.focus();
							}
							// Sinon on cible le premier lien parent
							const getParentEl =
								parent.parentNode.parentNode.parentNode
									.parentNode as HTMLElement;
							if (getParentEl.nextElementSibling) {
								getParentEl.nextElementSibling
									.querySelector('a')
									.focus();
							}
						}
					}
					// Si l'item n'a pas d'enfants
					else {
						// Si next sibling
						if (parent.nextElementSibling) {
							parent.nextElementSibling
								.querySelector('a')
								.focus();
						} else {
							// Sinon on target le lien de l'item parent
							const nextElParent = parent.parentNode.parentNode as HTMLElement;
							const nextEl =
								nextElParent.nextElementSibling as HTMLElement;
							if (nextEl) {
								nextEl.querySelector('a').focus();
							}
							// Si pas de next El on ferme le sous menu
							else {
								const getParent = parent.parentNode.parentNode.parentNode as HTMLElement;
								getParent.classList.remove(
									'sub-menu--a11Y'
								);
								const getParentEl =
									parent.parentNode.parentNode.parentNode
										.parentNode as HTMLElement;
								if (getParentEl.nextElementSibling) {
									getParentEl.nextElementSibling
										.querySelector('a')
										.focus();
								}
							}
						}
					}
				}
				// gestion flèche du haut
				if (up) {
					// Si prev sibling
					if (parent.previousElementSibling) {
						parent.previousElementSibling
							.querySelector('a')
							.focus();
					} else {
						// Sinon on focus le lien du li parent
						parent.parentNode.parentNode.querySelector('a').focus();
						// si on press up sur le premier item du submenu, on ferme le submenu
						if (
							parent.classList.contains('menu-item-has-children')
						) {
							const subMenuOpen =
								document.querySelectorAll('.sub-menu--a11Y') ||
								null;
							if (subMenuOpen) {
								subMenuOpen.forEach((submenu) =>
									submenu.classList.remove('sub-menu--a11Y')
								);
							}
						}
					}
				}
				// Gestion du Tab
				if (tab) {


					if (parent.nextElementSibling) {
						let getItem = parent.nextElementSibling.children[0] as HTMLElement;
						getItem.focus();
					}
					else {
						if (parent.parentNode.parentNode.nextSibling) {
							const item = parent.parentNode.parentNode as HTMLElement;
							if (item.nextElementSibling) {
								item.nextElementSibling.querySelector('a').focus();
								document.querySelectorAll('.sub-menu').forEach(item => {
									item.classList.remove('sub-menu--a11Y')
								})
							}
							else {
								document.getElementById('a42-ac-button').focus();
								document.querySelectorAll('.sub-menu').forEach(item => {
									item.classList.remove('sub-menu--a11Y')
								})
							}
						}


					}



				}
				// Gestion du shift + tab
				if (shiftTab) {
					const prevEl = parent.previousElementSibling;
					if (prevEl) {
						prevEl.querySelector('a').focus();
					} else {
						const firstParent = parent.parentNode as HTMLElement;
						firstParent.classList.remove('sub-menu--a11Y');
						const secondParent = parent.parentNode.parentNode as HTMLElement;
						if (
							secondParent.classList.contains(
								'menu-menu-principal-container'
							)
						) {
							const target = document.querySelector('.bypass-links a') as HTMLElement;
							target.focus();
						} else {
							parent.parentNode.parentNode
								.querySelector('a')
								.focus();
						}
					}
				}
				// Gestion touche echap, on ferme les sous-menus
				if (escape) {
					const subMenuOpen =
						document.querySelectorAll('.sub-menu--a11Y') || null;
					if (subMenuOpen) {
						const getParent = parent.parentNode.parentNode.parentNode.parentNode as HTMLElement;
						if (
							getParent.classList.contains(
								'menu-item'
							)
						) {
							getParent
								.querySelector('a')
								.focus();
						} else {
							parent.parentNode.parentNode
								.querySelector('a')
								.focus();
						}
						subMenuOpen.forEach((submenu) =>
							submenu.classList.remove('sub-menu--a11Y')
						);
					}
				}
			});
		});
	}
};

headerA11y();